import { useTheme } from "../../../../context/ThemeContext";
import { Tenant } from "../../../../types/Tenant";

export const Maintenance = ({ message }: { message: string | TrustedHTML }) => {

    const { tenant } = useTheme();
    return <div className={`w-screen h-screen bg-gray-800 flex items-center justify-center text-white applyHtml ${tenant !== Tenant.FLOTECH ? '[&_a]:text-flexprint' : '[&_a]:text-flotech'}`}>
        <div className="rounded p-8 bg-gray-700">
            <div className="logo mb-4">
                {tenant ? (
                  <img
                    src={require(`../../../../assets/images/${tenant}-header-logo.png`)}
                  />
                ) : (
                  ''
                )}
            </div>
            <div className={``} dangerouslySetInnerHTML={{ __html: message}}></div>
        </div>
    </div>
}